export const DASH = '-';
